import {Directive, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NotificationModel} from '../../../core-logic/models/notification/notification-model';
import {NotificationGatewayHttp} from '../../../adapters/real/api-services/gateways/notification-gateway-http';

@Directive({
  selector: '[appNotificationHasBeenSeen]'
})
export class NotificationHasBeenSeenDirective implements OnChanges {
  @Input() notificationToSee: NotificationModel;
  constructor(
    private elementRef: ElementRef,
    private notificationGatewayHttp: NotificationGatewayHttp
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.notificationToSee) {
      if (this.notificationToSee && !this.notificationToSee.seen_date) {
        this.notificationGatewayHttp.seeNotification(this.notificationToSee._id).subscribe();
      }
    }
  }

}
